var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerx"},[_c('vs-upload',{attrs:{"multiple":"","data-cy":"dropzone","text":"Wgraj Umowę","show-upload-button":false},on:{"change":_vm.handleChange,"on-delete":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }